import * as Yup from "yup";
const generalErrorMessage = "Field is required";

// const validationSchemaWithRequiredFields = Yup.object({
//     cn_n_networks: Yup.array()
//         .required(generalErrorMessage)
//         .min(1, generalErrorMessage),
//     // cn_n_networks_other: Yup.string().when("cn_n_networks", {
//     //   is: (cn_n_networks) => cn_n_networks && cn_n_networks.includes(10),
//     //   then: () =>
//     //     Yup.string()
//     //       .required("Network other is required")
//     //       .min(1, "Network other is required."),
//     //   otherwise: () => Yup.string().optional(),
//     // }),
//     cn_atm_networks: Yup.array(Yup.string())
//         .required("At least one network must be selected")
//         .min(1, "At least one network must be selected"),
//     // cn_atm_networks_other: Yup.string().when("cn_atm_networks", {
//     //   is: (networks) => networks && networks.includes("5"),
//     //   then: () =>
//     //     Yup.string()
//     //       .required("Network other is required")
//     //       .min(1, "Network other is required."),
//     //   otherwise: () => Yup.string().optional(),
//     // }),
//     // cn_bin_Information: Yup.string()
//     //   .required(generalErrorMessage)
//     //   .min(1, generalErrorMessage),
//     cn_n_networks_other: Yup.string().when("cn_n_networks", {
//         is: (cn_n_networks) => cn_n_networks && cn_n_networks.includes(10),
//         then: () =>
//             Yup.string()
//                 .required("Network other is required")
//                 .min(1, "Network other is required."),
//         otherwise: () => Yup.string().optional(),
//     }),
//     cn_atm_networks_other: Yup.string().when("cn_atm_networks", {
//         is: (networks) => networks && networks.includes("5"),
//         then: () =>
//             Yup.string()
//                 .required("Network other is required")
//                 .min(1, "Network other is required."),
//         otherwise: () => Yup.string().optional(),
//     }),
//     cn_bin_Information: Yup.string()
//         .optional(),
//     cn_business_id: Yup.string()
//         .optional(),
//     cn_bin_no: Yup.string().optional(),
//     cn_settlement_currency: Yup.string().optional(),
//     cn_bin_quantity: Yup.string().optional(),
//     cn_bin_quantity_other: Yup.string().when("cn_bin_quantity", {
//         is: (cn_bin_quantity) => cn_bin_quantity && cn_bin_quantity === "other",
//         then: () =>
//             Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
//         otherwise: () => Yup.string().optional(),
//     }),
//     cn_bin_type: Yup.string().optional(),
//     cn_target_date: Yup.string().optional(),
//     cn_insurance_region: Yup.string().optional(),
//     cn_additional_card_information: Yup.array().optional(),
//     cn_additional_card_information_other: Yup.string().when(
//         "cn_additional_card_information",
//         {
//             is: (types) => types && types.includes(4),
//             then: () =>
//                 Yup.string().required("Additional option other is required"),
//             otherwise: () => Yup.string().optional(),
//         },
//     ),
//     cn_chip_profile: Yup.string()
//         .optional(),
//     cn_card_option: Yup.string()
//         .required(generalErrorMessage)
//         .min(1, generalErrorMessage),
//     cn_card_number: Yup.string().when("cn_card_option", {
//         is: (cn_card_option) =>
//             [
//                 "virtual-and-physical-simultaneous",
//                 "virtual-and-physical-on-demand",
//             ].includes(cn_card_option),
//         then: () =>
//             Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
//         otherwise: () => Yup.string().optional(),
//     }),
//     cn_card_information: Yup.array().optional(),
//     cn_card_information_other: Yup.string().when("cn_card_information", {
//         is: (types) => types && types.includes(4),
//         then: () => Yup.string().required("Card option other is required"),
//         otherwise: () => Yup.string().optional(),
//     }),
// });

const optionalString = Yup.string().optional();
const optionalArray = Yup.array().optional();

// const minIfPresentArray = (message) =>
//     Yup.array().test(
//         "min-if-present",
//         message,
//         (val) => !val || val.length > 0
//     );

export const validationSchema = Yup.object({

    cn_n_networks: optionalArray,

    cn_n_networks_other: Yup.string().test(
        "network-other",
        "Network other is required",
        function (val) {
            const networks = this.parent.cn_n_networks || [];
            if (networks.includes(10)) {
                return !val || val.length > 0; // optional but valid if filled
            }
            return true;
        }
    ),

    cn_atm_networks: optionalArray.of(Yup.string()),

    cn_atm_networks_other: Yup.string().test(
        "atm-network-other",
        "Network other is required",
        function (val) {
            const networks = this.parent.cn_atm_networks || [];
            if (networks.includes("5")) {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    cn_bin_Information: optionalString,
    cn_business_id: optionalString,
    cn_ica: optionalString,
    cn_bin_no: optionalString,
    cn_settlement_currency: optionalString,

    cn_bin_quantity: optionalString,

    cn_bin_quantity_other: Yup.string().test(
        "bin-quantity-other",
        generalErrorMessage,
        function (val) {
            const qty = this.parent.cn_bin_quantity;
            if (qty === "other") {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    cn_bin_type: optionalString,
    cn_target_date: optionalString,
    cn_insurance_region: optionalString,

    cn_additional_card_information: optionalArray,

    cn_additional_card_information_other: Yup.string().test(
        "additional-card-other",
        "Additional option other is required",
        function (val) {
            const types = this.parent.cn_additional_card_information || [];
            if (types.includes(4)) {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    cn_chip_profile: optionalString,

    cn_card_option: optionalString,

    cn_card_number: Yup.string().test(
        "card-number-condition",
        generalErrorMessage,
        function (val) {
            const option = this.parent.cn_card_option;
            const requiresCardNumber = [
                "virtual-and-physical-simultaneous",
                "virtual-and-physical-on-demand",
            ].includes(option);

            if (requiresCardNumber) {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    cn_card_information: optionalArray,

    cn_card_information_other: Yup.string().test(
        "card-info-other",
        "Card option other is required",
        function (val) {
            const types = this.parent.cn_card_information || [];
            if (types.includes(4)) {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

});
export const validationSchemaAutomaticAccountUpdater = Yup.object({
    cn_automatic_account_updater_service_mastercard_automatic_billing_updater: Yup.string()
        .optional()
        .oneOf(["yes", "no", "n/a"], "Invalid selection"),
    cn_automatic_account_updater_service_visa_account_updater: Yup.string()
        .optional()
        .oneOf(["yes", "no", "n/a"], "Invalid selection"),
});

// Validation Schema
export const validationSchemaAdditionalNetworkServices = Yup.object({
    cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin: Yup.string()
        .optional(),
    cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin_other: Yup.string().when(
        "cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin",
        {
            is: (value) => value === "other",
            then: () => Yup.string().optional(),
            otherwise: () => Yup.string().optional(),
        }
    ),
    cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin: Yup.string()
        .optional(),
    cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin_other: Yup.string().when(
        "cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin",
        {
            is: (value) => value === "other",
            then: () => Yup.string().optional(),
            otherwise: () => Yup.string().optional(),
        }
    ),
});